var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCuillust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_953",
    "data-name": "Group 953",
    xmlns: "http://www.w3.org/2000/svg",
    width: 564.553,
    height: 422.209,
    viewBox: "0 0 564.553 422.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M58.22,0H320.869V271.931c0,33.032-9.438,65.649-28.728,92.459a138.5,138.5,0,0,1-59.79,47.759c-17.112,7.1-35.625,10.06-54.137,10.06h-58.6V329.284l61.345-1.919s42.159,0,40.24-65.183H58.22Z",
    transform: "translate(243.684)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M0,0H262.649V271.931c0,33.032-9.438,65.649-28.728,92.459a138.5,138.5,0,0,1-59.79,47.759c-17.112,7.1-35.625,10.06-54.137,10.06H61.4V329.284l61.345-1.919s42.159,0,40.24-65.183H0Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuillust);
export default __webpack_public_path__ + "static/media/cuillust.480a2551cfdc8cac0ebc771a7c920ade.svg";
export { ForwardRef as ReactComponent };